export const DEFAULT_LOCALE = 'en-US';

export const SUPPORTED_LOCALES = Object.freeze([
  { code: 'en-US', languageCode: 'en', label: 'English' },
  { code: 'it-IT', languageCode: 'it', label: 'Italiano' },
  { code: 'es-ES', languageCode: 'es', label: 'Espanol' },
]);

const SUPPORTED_CODES = new Set(SUPPORTED_LOCALES.map((entry) => entry.code));
const LANGUAGE_FALLBACKS = new Map(SUPPORTED_LOCALES.map((entry) => [entry.languageCode, entry.code]));

export const normalizeLocale = (rawLocale, fallback = DEFAULT_LOCALE) => {
  if (!rawLocale || typeof rawLocale !== 'string') {
    return fallback;
  }

  const trimmed = rawLocale.trim().replace('_', '-');
  if (!trimmed) {
    return fallback;
  }

  if (SUPPORTED_CODES.has(trimmed)) {
    return trimmed;
  }

  const lower = trimmed.toLowerCase();
  const exact = SUPPORTED_LOCALES.find((entry) => entry.code.toLowerCase() === lower);
  if (exact) {
    return exact.code;
  }

  const languageCode = lower.split('-')[0];
  return LANGUAGE_FALLBACKS.get(languageCode) || fallback;
};

export const detectDeviceLocale = () => {
  const browserLocale = typeof navigator !== 'undefined'
    ? navigator.language || navigator.languages?.[0]
    : null;
  return normalizeLocale(browserLocale);
};

export const getLocaleLabel = (locale) =>
  SUPPORTED_LOCALES.find((entry) => entry.code === normalizeLocale(locale))?.label || 'English';
